import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, Observable, combineLatest } from 'rxjs';
import {
  catchError,
  filter,
  map,
  mergeMap,
  switchMap,
  withLatestFrom
} from 'rxjs/operators';
import {
  ManagerActionTypes,
  LoadManagerSuccess,
  LoadManagerFail,
  ManagerLoadDealDetailsFailed,
  ManagerLoadDealDetailsSuccess
} from './actions';
import { ManagerDealSelection } from './selection/actions';
import { selectManagerState } from '../reducer';
import { ManagerState } from './state';
import { ManagerService } from '../../services/manager.service';
import { DealVersion } from '../../types/deal.types';
import { select, Store } from '@ngrx/store';
import { State } from '../reducer';
import { OrderService } from '../../services/order.service';
import { ManagerSelectionActionTypes } from './selection/actions';

@Injectable()
export class ManagerEffects {
  
  public loadDeals$: Observable<
    LoadManagerSuccess | LoadManagerFail
  > = createEffect(() => this.actions$.pipe(
    ofType(ManagerActionTypes.LoadManager),
    switchMap(() =>
      this.managerService.getDeals().pipe(
        map((deals: DealVersion[]) => new LoadManagerSuccess({ data: deals })),
        catchError((error) =>
          of(new LoadManagerFail(error && (error as Error).message))
        )
      )
    )
  ));

  
  public selectDeal$: Observable<
    ManagerLoadDealDetailsSuccess | ManagerLoadDealDetailsFailed
  > = createEffect(() => this.actions$.pipe(
    ofType(ManagerSelectionActionTypes.ManagerDealSelection),
    withLatestFrom(this.store.pipe(select(selectManagerState))),
    filter(
      ([action, state]: [ManagerDealSelection, ManagerState]) =>
        action.selected && !state.dealsDetails[action.dealId]
    ),
    mergeMap(([action]: [ManagerDealSelection, ManagerState]) =>
      combineLatest(
        this.orderService.getOrders(action.dealId).pipe(
          catchError(() => {
            return of(undefined);
          })
        ),
        this.managerService.getDealShowTypeDeal(action.dealId)
      ).pipe(
        map(
          ([orders, deal]) =>
            new ManagerLoadDealDetailsSuccess({
              dealId: action.dealId,
              orders: orders,
              dealDetails: deal
            })
        ),
        catchError((err) =>
          of(
            new ManagerLoadDealDetailsFailed({
              error:
                err.error && err.error.message
                  ? err.error.message
                  : err.message,
              dealId: action.dealId
            })
          )
        )
      )
    )
  ));

  constructor(
    public managerService: ManagerService,
    private actions$: Actions,
    private store: Store<State>,
    private orderService: OrderService
  ) {}
}
